import { HTMLAttributes, forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {
    display: 'flex',

    '&$end': {
      alignSelf: 'flex-end',
    },
  },
  start: {},
  end: {},
});

export interface InputGroupAndornmentProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {
  position?: 'start' | 'end';
}

const InputGroupAndornment = forwardRef<
  HTMLDivElement,
  InputGroupAndornmentProps
>(({ children, className, classes, position = 'start', ...rest }, ref) => {
  return (
    <div
      ref={ref}
      className={classNames(classes.root, classes[position], className)}
      data-slot="andornment"
      {...rest}
    >
      {children}
    </div>
  );
});

InputGroupAndornment.displayName = 'InputGroup.Andornment';

export default withStyles(styles)(InputGroupAndornment);
